import SpendingDemandList from "./SpendingDemandList";
import ManagerInfoCard from "./ManagerInfoCard";
import MembersList from "./MembersList";
import ProjectInfoCard from "./ProjectInfoCard";
import TeamHeaderTitle from "./TeamHeaderTitle";
import ModifyTeamBtn from "./ModifyTeamBtn";
import { TeamInfo } from "./TeamInfo";




export const SingleTeamComponents = {
    TeamHeaderTitle,
    MembersList,
    ManagerInfoCard,
    ProjectInfoCard,
    SpendingDemandList,
    ModifyTeamBtn,
    TeamInfo
}
export default SingleTeamComponents